import { render, staticRenderFns } from "./Feed.vue?vue&type=template&id=19e0166a&scoped=true"
import script from "./Feed.vue?vue&type=script&lang=js"
export * from "./Feed.vue?vue&type=script&lang=js"
import style0 from "./Feed.vue?vue&type=style&index=0&id=19e0166a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e0166a",
  null
  
)

export default component.exports